"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const FormSection_1 = require("../../../utils/FormSection");
const TwoStepTimePickerContainer_1 = require("./TwoStepTimePickerContainer");
const DaysOfWeekPicker_1 = require("./DaysOfWeekPicker");
const DatePickerContainer_1 = require("../../components/DatePickerContainer");
const reducers_1 = require("../../../../reducers");
const formatDateTime_1 = require("../../../../views/utils/formatDateTime");
const actions_1 = require("../../../../actions");
const CampaignDuration = ({ device, dayOfTheWeekFilter, endDateTime, startDateTime, updateScheduledEventTriggerFilter }) => (React.createElement(React.Fragment, null,
    React.createElement(FormSection_1.default, { device: device, style: { marginTop: 24 } },
        React.createElement(src_1.Text, { text: "Campaign Duration", size: "h1", textStyle: {
                marginBottom: 8,
            } }),
        React.createElement(DatePickerContainer_1.default, { date: startDateTime.date, device: device, field: "startDateTime", label: "Start Date", update: (date) => {
                updateScheduledEventTriggerFilter({
                    startDateTime: {
                        date,
                        time: 0,
                        timeZone: null,
                    },
                });
            }, maxDate: !!endDateTime.date
                ? new Date(endDateTime.date) < new Date()
                    ? new Date()
                    : new Date(endDateTime.date)
                : null, minDate: new Date() }),
        React.createElement(DatePickerContainer_1.default, { date: endDateTime ? endDateTime.date : undefined, device: device, field: "endDateTime", label: "End Date", update: (date) => {
                if (date.length === 0) {
                    updateScheduledEventTriggerFilter({
                        endDateTime: null,
                    });
                }
                else {
                    updateScheduledEventTriggerFilter({
                        endDateTime: {
                            date: date,
                            time: 86399,
                            timeZone: null,
                        },
                    });
                }
            }, minDate: startDateTime !== null ? formatDateTime_1.formatDate(startDateTime.date) : null, removeable: true })),
    React.createElement(FormSection_1.default, { device: device },
        React.createElement(src_1.Text, { text: "Additional Options", size: "h2", textStyle: {
                marginBottom: 8,
            } }),
        React.createElement(DaysOfWeekPicker_1.default, { device: device, key: JSON.stringify(dayOfTheWeekFilter) || '' }),
        React.createElement(TwoStepTimePickerContainer_1.default, { device: device }))));
const mapStateToProps = (state) => {
    const defaultDateTime = {
        date: null,
        time: null,
        timeZone: null,
    };
    const scheduledTrigger = reducers_1.getEditableCampaignScheduledEventTriggerFilter(state);
    return {
        dayOfTheWeekFilter: reducers_1.getEditableCampaignDayOfTheWeekEventTriggerFilter(state),
        endDateTime: scheduledTrigger && scheduledTrigger.endDateTime ? scheduledTrigger.endDateTime : defaultDateTime,
        startDateTime: scheduledTrigger && scheduledTrigger.startDateTime ? scheduledTrigger.startDateTime : defaultDateTime,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateScheduledEventTriggerFilter: (d) => {
            dispatch(actions_1.updateScheduledEventTriggerFilter(d));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CampaignDuration);
